module.exports = {
	"_args": [
		[
			{
				"raw": "deck.gl@^4.0.0",
				"scope": null,
				"escapedName": "deck.gl",
				"name": "deck.gl",
				"rawSpec": "^4.0.0",
				"spec": ">=4.0.0 <5.0.0",
				"type": "range"
			},
			"/Users/rrout/Code/Github/Deck.GL/latest/deck.gl/examples/arc"
		]
	],
	"_from": "deck.gl@>=4.0.0 <5.0.0",
	"_id": "deck.gl@4.0.6",
	"_inCache": true,
	"_location": "/deck.gl",
	"_nodeVersion": "6.5.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/deck.gl-4.0.6.tgz_1493316565851_0.3457634903024882"
	},
	"_npmUser": {
		"name": "shaojingli",
		"email": "lishaojing@gmail.com"
	},
	"_npmVersion": "3.10.3",
	"_phantomChildren": {},
	"_requested": {
		"raw": "deck.gl@^4.0.0",
		"scope": null,
		"escapedName": "deck.gl",
		"name": "deck.gl",
		"rawSpec": "^4.0.0",
		"spec": ">=4.0.0 <5.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/deck.gl/-/deck.gl-4.0.6.tgz",
	"_shasum": "8c0ccb0eb083fb89285997e54707e7b105f2f114",
	"_shrinkwrap": null,
	"_spec": "deck.gl@^4.0.0",
	"_where": "/Users/rrout/Code/Github/Deck.GL/latest/deck.gl/examples/arc",
	"babel": {
		"presets": [
			[
				"es2015",
				{
					"modules": false
				}
			]
		]
	},
	"bugs": {
		"url": "https://github.com/uber/deck.gl/issues"
	},
	"dependencies": {
		"d3-hexbin": "^0.2.1",
		"earcut": "^2.0.6",
		"gl-matrix": "^2.3.2",
		"lodash.flattendeep": "^4.4.0"
	},
	"description": "A suite of 3D-enabled data visualization overlays, suitable for react-map-gl",
	"devDependencies": {
		"babel-cli": "^6.22.2",
		"babel-core": "^6.22.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-static-fs": "^1.1.0",
		"babel-plugin-transform-es2015-modules-commonjs": "^6.22.0",
		"babel-polyfill": "^6.20.0",
		"babel-preset-es2015": "^6.4.3",
		"benchmark": "^2.1.3",
		"brfs-babel": "^1.0.0",
		"buble": "^0.15.1",
		"buble-loader": "^0.4.0",
		"colorbrewer": "^1.0.0",
		"eslint": "^3.0.0",
		"eslint-config-uber-es2015": "^3.0.0",
		"eslint-config-uber-jsx": "^3.0.0",
		"eslint-plugin-react": "~6.7.0",
		"faucet": "0.0.1",
		"file-loader": "^0.10.1",
		"gl": "^4.0.3",
		"immutable": "^3.8.1",
		"luma.gl": "^3.0.0",
		"module-alias": "^2.0.0",
		"path-exists-cli": "^1.0.0",
		"pre-commit": "^1.2.2",
		"raw-loader": "^0.5.1",
		"react": "^15.4.0",
		"react-addons-test-utils": "^15.4.2",
		"react-dom": "^15.4.0",
		"reify": "^0.4.4",
		"tap-browser-color": "^0.1.2",
		"tape": "^4.5.1",
		"tape-catch": "^1.0.4",
		"transform-loader": "^0.2.3",
		"uglify-js": "^2.6.1",
		"url-loader": "^0.5.7",
		"webpack": "^2.2.0",
		"webpack-dev-server": "^2.2.0"
	},
	"directories": {},
	"dist": {
		"shasum": "8c0ccb0eb083fb89285997e54707e7b105f2f114",
		"tarball": "https://registry.npmjs.org/deck.gl/-/deck.gl-4.0.6.tgz"
	},
	"files": [
		"dist",
		"dist-es6",
		"src"
	],
	"gitHead": "6dde6c97bb2fc68da69e9fb4e7201bbd6ae56532",
	"homepage": "https://github.com/uber/deck.gl#readme",
	"keywords": [
		"webgl",
		"visualization",
		"overlay",
		"layer"
	],
	"license": "MIT",
	"main": "dist/index.js",
	"maintainers": [
		{
			"name": "apercu",
			"email": "bgronon@gmail.com"
		},
		{
			"name": "gnavvy",
			"email": "gnavvy@gmail.com"
		},
		{
			"name": "heshan0131",
			"email": "heshan0131@gmail.com"
		},
		{
			"name": "ibgreen",
			"email": "ib.green.home@gmail.com"
		},
		{
			"name": "pessimistress",
			"email": "cxiaoji@gmail.com"
		},
		{
			"name": "shaojingli",
			"email": "lishaojing@gmail.com"
		}
	],
	"module": "dist-es6/index.js",
	"name": "deck.gl",
	"optionalDependencies": {},
	"peerDependencies": {
		"luma.gl": "^3.0.0",
		"react": "0.14.x - 15.x",
		"react-dom": "0.14.x - 15.x"
	},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/uber/deck.gl.git"
	},
	"scripts": {
		"bench": "node test/bench/node.js",
		"bench-browser": "webpack-dev-server --config webpack.config.bench-browser.js --progress --hot --open --port 3011",
		"build": "npm run build-clean && npm run build-es6 && npm run build-es5 && webpack -d --display-modules",
		"build-buble": "buble dist-es6 -o dist --no modules --y dangerousForOf --objectAssign",
		"build-clean": "rm -fr dist dist-es6 && mkdir -p dist dist-es6",
		"build-es5": "rm -fr dist && babel src --out-dir dist --plugins=static-fs,transform-es2015-modules-commonjs --source-maps inline",
		"build-es6": "rm -fr dist-es6 && babel src --out-dir dist-es6 --plugins=static-fs --source-maps inline",
		"lint": "eslint src test examples && npm run lint-yarn",
		"lint-yarn": "!(find . -name yarn.lock -exec grep -l unpm.u {} \\; | egrep '.*')",
		"publish-beta": "npm run build && npm run test && npm run test-dist && npm publish --tag beta",
		"publish-prod": "npm run build && npm run test && npm run test-dist && npm publish",
		"start": "(cd examples/layer-browser && (path-exists node_modules || npm i) && npm run start-local)",
		"test": "npm run lint && npm run test-node",
		"test-browser": "webpack-dev-server --config webpack.config.test-browser.js --progress --hot --open --port 3010",
		"test-dist": "node test/node-dist.js",
		"test-fp64": "(cd test/fp64-test && webpack-dev-server --config webpack.config.test-fp64.js --progress --hot --open)",
		"test-node": "node test/node.js",
		"test-rendering": "(cd test/rendering-test && webpack-dev-server --config webpack.config.test-rendering.js --progress --hot --open)"
	},
	"version": "4.0.6"
};


//////////////////
// WEBPACK FOOTER
// ./~/deck.gl/package.json
// module id = 523
// module chunks = 0